/* eslint-disable array-callback-return */
import { updateObject } from "../storeUtils";
import * as actionTypes from "../actions/actionTypes";
import _ from "underscore";
import APP_CONST from "../../../app/core/shared/constants";
const initialState = {
  docType: [],
  tmfLevel: [],
  reviewerAction: [],
  commentListArr: [],
  docItemData: {},
  AgGridDocument: {},
  deleteDocumentInfo: [],
  deletedDocumentGuid: "",
  lockDocumentChange: {},
  isDeleteLoading: false,
  isLoading: false,
  docStatusLoading: false,
  documentHistoryList: [],
  zoneData: [],
  commentList: [],
  noteArr: [],
  versionLoader: false,
  historyLoading: false,
  customizedColState: "undefined",
  customizedFilterState: "undefined",
  docShareCount: {
    availableBindersCount: 0,
    completedBindersCount: 0,
    inCompleteBindersCount: 0,
    minDocumentVersionNumber: 0,
    availableBindersWithRecalledCount: 0,
  },
  subjects: [],
  isBindersLoader: false,
  downloadSignatureLoader: false,
  binderRecallErrState: "",
  binderDetails: {},
  isBinderDetail: false,
  isBinderRecalling: false,
  binderListIds: [],
  showBinderDetailPage: false,
  docStatusChangeInProgress: false,
  documentsLoading: false,
  noteResolving: false,
  deletingDocId: "",
  accordanceData: [],
  docPropErrorMessage: "",
  deletingDocuments: [],
  isDeleting: false,
  isHistoryTriggered: false
};

export const documentReducer = (
  state = initialState,
  action = { type: "" }
) => {
  switch (action.type) {
    case actionTypes.GET_SELECTED_DOCUMENT_DETAIL:
      return updateObject(state, { versionLoader: true });
    case `${actionTypes.GET_SELECTED_DOCUMENT_DETAIL}_SUCCESS`:
      return updateObject(state, {
        selectedDocDetail: action.payload,
        versionLoader: false,
      });
    case `${actionTypes.GET_SELECTED_DOCUMENT_DETAIL}_FAILED`:
      return updateObject(state, {
        versionLoader: false,
        selectedDocDetail: {},
      });
    case `${actionTypes.GET_DOCUMENT_VERSION_LIST}_SUCCESS`:
      let versionList = action.payload;
      if (!_.isEmpty(versionList)) {
        versionList.map((version, index) => {
          versionList[index] = {
            value: version.documentversionnumber,
            label: version.documentversionnumber,
            ...version,
          };
        });
      }
      return updateObject(state, { documentVersionList: versionList });

    case actionTypes.CLEAR_DOCUMENT_VERSION_LIST:
      return updateObject(state, { documentVersionList: [] });

    case "AGGRID_GET_DOCUMENT":
      return updateObject(state, {
        AgGridDocument: {},
        isLoading: true,
      });

    case "AGGRID_GET_DOCUMENT_SUCCESS":
      let agdata = !action.payload.uselocalstorage
        ? action.payload
        : state.AgGridDocument;
      sessionStorage.setItem(
        "lastdocumentupdatedon",
        agdata.lastdocumentupdatedon
      );
      return updateObject(state, {
        AgGridDocument: action.payload,
        isLoading: false,
        docStatusChangeInProgress: false
      });

    case "AGGRID_GET_DOCUMENT_FAILURE":
      return updateObject(state, {
        AgGridDocument: {},
        isLoading: false,
      });

    case actionTypes.FETCH_LOAD_DOCUMENT_MASTER:
      return updateObject(state, { documentsLoading: true });

    case `${actionTypes.FETCH_LOAD_DOCUMENT_MASTER}_SUCCESS`:
      const docTypeNew = action.payload.documentType || [];
      const tmfLevelNew = action.payload.documentLevels || APP_CONST.TMF_LEVELS;
      const reviewerActionNew = action.payload.reviewerActionMasterDto || [];
      const zoneDataNew = !_.isEmpty(action.payload.zoneDataDto) ? action.payload.zoneDataDto.zonedata : [];
      return updateObject(state, {
        docType: docTypeNew,
        tmfLevel: tmfLevelNew,
        reviewerAction: reviewerActionNew,
        zoneData: zoneDataNew,
        documentsLoading: false,
      });

    case `${actionTypes.FETCH_LOAD_DOCUMENT_MASTER}_FAILED`:
      return updateObject(state, { docMaster: {}, documentsLoading: false });

    case `${actionTypes.FETCH_DOCUMENT_MASTER}_SUCCESS`:
      const {
        documentType,
        documentLevels,
        reviewerActionMasterDto,
        zoneDataDto,
      } = action.payload;
      const docType = documentType || [];
      const tmfLevel = documentLevels || APP_CONST.TMF_LEVELS;
      const reviewerAction = reviewerActionMasterDto || [];
      return updateObject(state, {
        docType,
        tmfLevel,
        reviewerAction,
        zoneData: zoneDataDto.zonedata,
      });
    case `${actionTypes.FETCH_DOCUMENT_MASTER}_FAILED`:
      return updateObject(state, { docMaster: {} });

    case "SET_ACCORDANCE_DATA":
      return updateObject(state, {
        accordanceData: action.payload
      });

    case "RESET_ACCORDANCE_DATA":
      return updateObject(state, {
        accordanceData: []
      });

    case `${actionTypes.FETCH_DOCUMENT_DELETE}`:
      let deletingDocumentsInfo = state.deletingDocuments;
      deletingDocumentsInfo.push(action.payload.id);
      return updateObject(state, {
        deletingDocId: action.payload.id,
        deletingDocuments: deletingDocumentsInfo,
        isDeleteLoading: true,
        isDeleting: true
      });
    case `${actionTypes.FETCH_DOCUMENT_DELETE}_SUCCESS`:
      let removeIds = state.deletingDocuments.filter((id) => id !== action.payload.id);
      return updateObject(state, {
        deletingDocId: action.payload.id,
        deletingDocuments: removeIds,
        deletedDocumentGuid: action.payload.documentguid,
        isDeleteLoading: false,
        isDeleting: false
      });
    case `${actionTypes.FETCH_DOCUMENT_DELETE}_FAILED`:
      return updateObject(state, {
        deletingDocId: '',
        deletingDocuments: [],
        isDeleteLoading: false,
        isDeleting: false
      });
    case actionTypes.DOCUMENT_STATUS_CHANGE:
      return updateObject(state, { docStatusLoading: true });
    case actionTypes.DOCUMENT_STATUS_CHANGE_SUCCESS:
      return updateObject(state, {
        docItemData: action.payload,
        docStatusLoading: false,
      });
    case actionTypes.DOCUMENT_STATUS_CHANGE_FAILED:
      return updateObject(state, { docItemData: {}, docStatusLoading: false, docStatusChangeInProgress: false });

    case `${actionTypes.FETCH_DOCUMENT_LOCK}`:
      return updateObject(state, { docStatusLoading: true });
    case `${actionTypes.FETCH_DOCUMENT_LOCK}_SUCCESS`:
      const updateDocumentPayload = {
        ...(action.payload.documentDetails || {}),
        ...action.payload,
      };
      const documentDetails = { documentDetails: { ...updateDocumentPayload } };
      const lockDocumentObj = {
        documentcontents: JSON.stringify(documentDetails),
      };
      return updateObject(state, {
        docItemData: lockDocumentObj,
        lockDocumentChange: updateDocumentPayload,
        docStatusLoading: false,
      });
    case `${actionTypes.FETCH_DOCUMENT_LOCK}_FAILED`:
      return updateObject(state, { docStatusLoading: false, docPropErrorMessage: action.payload });

    case `${actionTypes.GET_ADMIN_SHARING_SETTING}_SUCCESS`:
      return updateObject(state, {
        adminSharingSettings: action.payload,
      });

    case `${actionTypes.CLEAR_DOCERROR_MESSAGE}`:
      return updateObject(state, {
        docPropErrorMessage: "",
      })

    case `${actionTypes.GET_SHARING_METRICS_BY_VERSION}`:
      return updateObject(state, {
        metricsLoader: true,
      });
    case `${actionTypes.GET_SHARING_METRICS_BY_VERSION}_FAILED`:
      return updateObject(state, {
        metricsLoader: false,
      });
    case `${actionTypes.GET_SHARING_METRICS_BY_VERSION}_SUCCESS`:
      let docShareCount = state.docShareCount;
      docShareCount = {
        ...docShareCount,
        availableBindersCount: action.payload.availableBindersCount,
        completedBindersCount: action.payload.completedBindersCount,
        inCompleteBindersCount: action.payload.inCompleteBindersCount,
        minDocumentVersionNumber: action.payload.minDocumentVersionNumber,
        availableBindersWithRecalledCount:
          action.payload.availableBindersWithRecalledCount,
      };
      return updateObject(state, {
        docShareCount: docShareCount,
        metricsLoader: false,
      });

    case `${actionTypes.IS_BINDERS_CALL_RUNNING}`:
      return updateObject(state, {
        isBindersCallRunning: action.payload,
      });

    case `${actionTypes.GET_SHARED_FILE_COUNT}`:
      return updateObject(state, {
        isShareLoading: true,
      });
    case `${actionTypes.GET_SHARED_FILE_COUNT}_SUCCESS`:
      let updatedSignatureList = action.payload.signaturereasons;
      let updatedRecipientList =
        action.payload.tmfsharingfilesreciepients.clinicalusers;
      let recipientListValues = [];
      let signatureListValues = [];
      updatedSignatureList.map((user) => {
        signatureListValues.push({ value: user, label: user });
      });
      updatedRecipientList.map((user) => {
        recipientListValues.push({
          value: user.username,
          label: user.username,
          ...user,
        });
      });
      return updateObject(state, {
        signatureReason: signatureListValues,
        sharedRecipients: recipientListValues,
        subjects: action.payload.tmfsharingfilesreciepients.subjects,
        isShareLoading: false,
      });
    case `${actionTypes.GET_SHARED_FILE_COUNT}_FAILED`:
      return updateObject(state, {
        isShareLoading: false,
      });

    case actionTypes.GET_EXISTING_SHARED_USER_LIST:
      return updateObject(state, {
        isAggridLoading: true,
      });
    case `${actionTypes.GET_EXISTING_SHARED_USER_LIST}_SUCCESS`:
      let binderListIds = action.payload.binderList.map((user) => {
        return { sharingBinderId: user.sharingBinderId, binderId: user.binderId }
      });
      return updateObject(state, {
        existingUsersList: action.payload.binderList,
        binderListIds: binderListIds,
        lastbindercreatedon: action.payload.lastbindercreatedon,
        isAggridLoading: false,
        isBinderDetail: false,
        metricsLoader: false,
      });
    case `${actionTypes.GET_EXISTING_SHARED_USER_LIST}_FAILED`:
      return updateObject(state, {
        isAggridLoading: false,
        metricsLoader: false,
      });

    case `${actionTypes.CLEAR_BINDER_METRICS}`:
      return updateObject(state, {
        docShareCount: {
          availableBindersCount: 0,
          completedBindersCount: 0,
          inCompleteBindersCount: 0,
          availableBindersWithRecalledCount: 0,
        },
      });

    case `${actionTypes.GET_DOC_SHARE_USER_LIST}_SUCCESS`:
      let docShareUsers = state.docShareUsers;
      let { viedocmeusers, viedocusers } = action.payload;
      let userRoleGroups = !_.isEmpty(viedocusers) && viedocusers.map((user) => {
        return user.rolegroupname;
      });
      userRoleGroups = !_.isEmpty(userRoleGroups) && userRoleGroups.filter(
        (group, index) => userRoleGroups.indexOf(group) === index
      );
      let subjectSiteCodeGroups = !_.isEmpty(viedocmeusers) && viedocmeusers.map((subject) => {
        return subject.sitegroupname;
      });
      subjectSiteCodeGroups = !_.isEmpty(subjectSiteCodeGroups) && subjectSiteCodeGroups.filter(
        (group, index) => subjectSiteCodeGroups.indexOf(group) === index
      );
      let mappedViedocMeUsers = [];
      !_.isEmpty(viedocmeusers) &&
        viedocmeusers.map((user) => {
          user = {
            ...user,
            label: user.displayName,
            value: user.displayName,
          };
          mappedViedocMeUsers.push(user);
        });
      let mappedViedocUsers = [];
      !_.isEmpty(viedocusers) &&
        viedocusers.map((user) => {
          user = {
            ...user,
            label: user.displayName,
            value: user.displayName,
          };
          mappedViedocUsers.push(user);
        });
      let groupOptForViedocUser = [];
      !_.isEmpty(userRoleGroups) &&
        userRoleGroups.map((role) => {
          return groupOptForViedocUser.push({
            label: role,
            options: mappedViedocUsers.filter(
              (user) => user.rolegroupname === role
            ),
          });
        });
      let groupOptForViedocMeUser = [];
      !_.isEmpty(subjectSiteCodeGroups) &&
        subjectSiteCodeGroups.map((subject) => {
          return groupOptForViedocMeUser.push({
            label: subject,
            options: mappedViedocMeUsers.filter(
              (user) => user.sitegroupname === subject
            ),
          });
        });
      let clinicalUserGroup = _.groupBy(mappedViedocUsers, "rolegroupname");
      let clinicalUserOption = [];
      !_.isEmpty(userRoleGroups) &&
        userRoleGroups.map((role) => {
          return clinicalUserOption.push(
            ...[{ label: role, displayNamewithrole: role, disable: true }],
            ...clinicalUserGroup[role]
          );
        });
      let subjectUserGroup = _.groupBy(mappedViedocMeUsers, "sitegroupname");
      let subjectUserOption = [];
      !_.isEmpty(subjectSiteCodeGroups) &&
        subjectSiteCodeGroups.map((subject) => {
          return subjectUserOption.push(
            ...[
              { label: subject, displayNamewithrole: subject, disable: true },
            ],
            ...subjectUserGroup[subject]
          );
        });

      docShareUsers = {
        viedocmeusers: mappedViedocMeUsers,
        viedocusers: mappedViedocUsers,
        groupOptForViedocUser: groupOptForViedocUser,
        groupOptForViedocMeUser: groupOptForViedocMeUser,
        userRoleGroups: userRoleGroups,
        clinicalUserOption: clinicalUserOption,
        subjectUserOption: subjectUserOption,
      };
      return updateObject(state, {
        docShareUsers: docShareUsers,
      });

    case actionTypes.GET_SELECTED_DOCUMENT_HISTORY:
      return updateObject(state, {
        docStatusLoading: true,
        historyLoading: true,
      });
    case `${actionTypes.GET_SELECTED_DOCUMENT_HISTORY}_SUCCESS`:
      return updateObject(state, {
        documentHistoryList: action.payload,
        docStatusLoading: false,
        historyLoading: false,
      });
    case `${actionTypes.GET_SELECTED_DOCUMENT_HISTORY}_FAILED`:
      return updateObject(state, {
        docStatusLoading: false,
        historyLoading: false,
      });

    case `${actionTypes.DOCUMENT_STATUS_GET_REVIEW}_SUCCESS`:
      return updateObject(state, { commentList: action.payload });
    case `${actionTypes.DOCUMENT_STATUS_GET_REVIEW}_FAILED`:
      return updateObject(state, { commentList: [] });

    case actionTypes.DOCUMENT_STATUS_SAVE_REVIEW:
      return updateObject(state, { docStatusLoading: true });
    case `${actionTypes.DOCUMENT_STATUS_SAVE_REVIEW}_SUCCESS`:
      return updateObject(state, { docStatusLoading: false });
    case `${actionTypes.DOCUMENT_STATUS_SAVE_REVIEW}_FAILED`:
      return updateObject(state, { docStatusLoading: false, docPropErrorMessage: action.payload, docStatusChangeInProgress: false });

    case actionTypes.ADD_DOC_NOTE:
      return updateObject(state, {});
    case `${actionTypes.ADD_DOC_NOTE}_SUCCESS`:
      let notesList = action.payload.documentNotesDetails;
      let noteChangedDate = action.payload.lastmodifiedon;
      return updateObject(state, {
        noteArr: notesList,
        noteModifiedDate: noteChangedDate,
        isArtifactCall: true,
      });
    case `${actionTypes.GET_DOC_NOTE}_SUCCESS`:
      let notesDetail = action.payload.documentNotesDetails;
      let noteDate = action.payload.lastmodifiedon;
      return updateObject(state, {
        noteArr: notesDetail,
        noteModifiedDate: noteDate,
      });

    case actionTypes.RESOLVE_DOC_NOTE:
      return updateObject(state, { noteResolving: true });

    case `${actionTypes.RESOLVE_DOC_NOTE}_SUCCESS`:
      let noteResolvedDate = action.payload.lastmodifiedon;
      return updateObject(state, {
        noteModifiedDate: noteResolvedDate,
        isArtifactCall: true,
        noteResolving: false,
      });

    case `${actionTypes.RESOLVE_DOC_NOTE}_FAILED`:
      return updateObject(state, { noteResolving: false });

    case actionTypes.CLEAR_DOC_NOTE:
      return updateObject(state, {
        noteArr: [],
        isArtifactCall: false,
      });

    case actionTypes.GET_DOCUMENT_CONTENT_DETAILS:
      return updateObject(state, {
        isDocContentLoader: true,
      });
    case `${actionTypes.GET_DOCUMENT_CONTENT_DETAILS}_FAILED`:
      return updateObject(state, {
        isDocContentLoader: false,
      });
    case `${actionTypes.GET_DOCUMENT_CONTENT_DETAILS}_SUCCESS`:
      return updateObject(state, {
        documentContentDetails: action.payload,
        isDocContentLoader: false,
      });

    case actionTypes.GET_MILESTONE_ARTIFACT_COUNT:
      return updateObject(state, {
        isMilestoneViewLoading: true,
      });
    case `${actionTypes.GET_MILESTONE_ARTIFACT_COUNT}_FAILED`:
      return updateObject(state, {
        isMilestoneViewLoading: false,
      });
    case `${actionTypes.GET_MILESTONE_ARTIFACT_COUNT}_SUCCESS`:
      let artifactList = action.payload;
      let artifactCount = _.filter(artifactList, { isdeleted: false }).length;

      return updateObject(state, {
        artifactCount: artifactCount,
        artifactList: artifactList,
        isMilestoneViewLoading: false,
      });

    case `${actionTypes.GET_CUSTOMIZED_COLSTATE}_SUCCESS`:
      let customColState =
        action.payload.userpreference === null ||
          action.payload.userpreference === "{}"
          ? "{}"
          : action.payload.userpreference;
      let customFilState =
        action.payload.filterpreference === null ||
          action.payload.filterpreference === "{}"
          ? "{}"
          : action.payload.filterpreference;
      sessionStorage.removeItem("customizedColState");
      sessionStorage.removeItem("customizedFilterState");
      sessionStorage.setItem("customizedColState", customColState);
      sessionStorage.setItem("customizedFilterState", customFilState);
      sessionStorage.removeItem("tempCustomizedColState");
      sessionStorage.removeItem("tempCustomizedFilterState");
      sessionStorage.removeItem("tempDefaultColState");
      sessionStorage.removeItem("tempDefaultFilterState");
      return updateObject(state, {
        customizedColState: customColState,
        customizedFilterState: customFilState,
      });

    case actionTypes.GET_BINDERS_DETAIL:
      return updateObject(state, {
        isBindersLoader: true,
        isBinderDetail: false,
      });
    case `${actionTypes.GET_BINDERS_DETAIL}_FAILED`:
      return updateObject(state, {
        isBinderDetail: false,
        isBindersLoader: false,
      });
    case `${actionTypes.GET_BINDERS_DETAIL}_SUCCESS`:
      return updateObject(state, {
        binderDetails: action.payload,
        isBindersLoader: false,
        isBinderDetail: true,
      });
    case "MAKE_BINDER_LIST_VISIBLE":
      return updateObject(state, {
        isBinderDetail: false,
      })
    case `${actionTypes.CREATE_NEW_BINDER_FOR_SHARING}`:
      return updateObject(state, {
        isBindersLoader: true,
      });
    case `${actionTypes.CREATE_NEW_BINDER_FOR_SHARING}_SUCCESS`:
      return updateObject(state, {
        isBindersLoader: false,
      });
    case `${actionTypes.CREATE_NEW_BINDER_FOR_SHARING}_FAILED`:
      return updateObject(state, {
        createBinderError: action.payload,
        isBindersLoader: false,
      });

    case actionTypes.GET_BINDERS_HISTORY:
      return updateObject(state, {
        bindersSpinner: true,
      });
    case `${actionTypes.GET_BINDERS_HISTORY}_FAILED`:
      return updateObject(state, {
        bindersSpinner: false,
      });
    case `${actionTypes.GET_BINDERS_HISTORY}_SUCCESS`:
      return updateObject(state, {
        bindersHistoryDetail: action.payload,
        bindersSpinner: false,
      });
    case `${actionTypes.DOWNLOAD_SIGNATURE_DETAILS}_FAILED`:
      return updateObject(state, {
        downloadSignatureLoader: false,
      });
    case `${actionTypes.DOWNLOAD_SIGNATURE_DETAILS}_SUCCESS`:
      return updateObject(state, {
        downloadSignatureLoader: false,
      });

    case `${actionTypes.DOWNLOAD_SIGNATURE_DETAILS}`:
      return updateObject(state, {
        downloadSignatureLoader: true,
      });
    case `${actionTypes.RECALL_BINDER}`:
      return updateObject(state, {
        isBinderRecalling: true,
      });
    case `${actionTypes.RECALL_BINDER}_SUCCESS`:
      return updateObject(state, {
        binderDetails: action.payload,
        isBinderRecalling: false,
      });
    case `${actionTypes.RECALL_BINDER}_FAILED`:
      return updateObject(state, {
        binderRecallErrState: action.payload,
        isBinderRecalling: false,
      });
    case actionTypes.SHOW_BINDER_DETAIL_PAGE:
      return updateObject(state, {
        showBinderDetailPage: action.payload
      });

    case actionTypes.DOCUMENT_STATUS_IN_PROGRESS:
      return updateObject(state, {
        docStatusChangeInProgress: true
      })

    case `${actionTypes.DOCUMENT_STATUS_IN_PROGRESS}_SUCCESS`:
      return updateObject(state, {
        docStatusChangeInProgress: false
      })

    case `${actionTypes.DOCUMENT_STATUS_IN_PROGRESS}_FAILED`:
      return updateObject(state, {
        docStatusChangeInProgress: false,
        docPropErrorMessage: action.payload
      })

    case actionTypes.REMOVE_AG_GRID_LIST:
      let deletingDocuments = state.deletingDocuments;
      deletingDocuments.push(action.payload.id);

      return updateObject(state, {
        deletingDocuments: deletingDocuments,
        isDeleting: true
      })

    case `${actionTypes.REMOVE_AG_GRID_LIST}_SUCCESS`:
      const removeFiles = action.payload.fileguid ? state.deletingDocuments.filter(
        (id) => id !== action.payload.fileguid
      ) : state.deletingDocuments.filter(
        (id) => id !== action.payload.documentid
      );
      return updateObject(state, {
        deletingDocuments: removeFiles,
        isDeleting: false
      })

    case `${actionTypes.REMOVE_AG_GRID_LIST}_FAILED`:
      return updateObject(state, {
        deletingDocuments: [],
        isDeleting: false
      })
    
    case actionTypes.IS_DOCUMENT_STATUS_CHANGE_HISTORY:
      return updateObject(state, {
        isHistoryTriggered: action.payload
      })
    default:
      return state;
  }
};
